<style lang="scss" scoped>
section.state {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;

  .error {
    .message {
      font-size: 14pt;
      text-align: center;
    }

    button {
      background-color: transparent;
      border: 1px solid #1b5e20;
      border-radius: 6px;
      color: #1b5e20;
      display: inline-block;
      margin: 2em auto;
      padding: .5em 2em;

      &:hover {
        background-color: #1b5e1b;
        color: #fff;
      }
    }

    span {
      margin: 0 1em;
    }

    .back-home {
      background-color: transparent;
      border: 1px solid #a01503;
      border-radius: 6px;
      color: #a01503;
      display: inline-block;
      margin: 2em auto;
      padding: .5em 1em;

      &:hover {
        background-color: #a01503;
        color: #fff;
        text-decoration: none;
      }
    }
  }

  .loading {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100vh;
    justify-content: center;
  }
}
</style>

<template>
  <div class="container">
    <section class="state">
      <div v-if="error">
        <div class="error">
          <p class="message">
            Oops!<br>
            A problem were occurred.
          </p>
          <button @click="retryLogin">
            Retry
          </button>
          <span>or</span>
          <router-link to="/" class="back-home">
            Back to Home
          </router-link>
        </div>
      </div>
      <div v-else>
        <div class="loading">
          <LoadingAnimation/>
          <div v-if="state === 'redirecting'">
            Redirecting...
          </div>
          <div v-else-if="state === 'fetching'">
            Logging in...
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { redirectIfLoggedIn } from '@/helpers/loginChecker';
import LoadingAnimation from '@/components/LoadingAnimation.vue';

function displayError(vm) {
  vm.toggleError();
}

async function login(vm) {
  vm.updateState('redirecting');

  const { VUE_APP_TEARY_BACKEND_API_URL } = process.env;
  const apiUrl = VUE_APP_TEARY_BACKEND_API_URL;

  try {
    const req = await fetch(`${apiUrl}/auth/login:google`);

    if (!req) {
      displayError(vm);
      return;
    }

    const res = await req.json();

    if (!res.ok) {
      displayError(vm);
      return;
    }

    const loginUrl = res.data.url;

    window.location = loginUrl;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error(error);
    }

    displayError(vm);
  }
}

async function processLogin(vm) {
  vm.updateState('fetching');

  const { VUE_APP_TEARY_BACKEND_API_URL } = process.env;
  const apiUrl = VUE_APP_TEARY_BACKEND_API_URL;

  const { code, type } = vm.$route.query;
  const oauthRequestId = vm.$route.query.oauth_request_id;
  const urlQueries = `oauth_request_id=${oauthRequestId}&type=${type}&code=${code}`;

  const loginUrl = `${apiUrl}/auth/login:verify?${urlQueries}`;

  try {
    const req = await fetch(loginUrl);

    if (!req) {
      displayError(vm);
      return;
    }

    const res = await req.json();

    if (!res.ok) {
      displayError(vm);
      return;
    }

    const { data } = res;
    const { token, user } = data;

    delete user.created_at;
    delete user.deleted_at;
    delete user.updated_at;
    delete user.google_access_token;
    delete user.google_refresh_token;
    delete user.google_token_expiry_date;

    vm.$cookies.set('token', token);
    vm.$cookies.set('user', user);

    vm.$router.push('assignments');
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error(error);
    }

    displayError(vm);
  }
}

export default {
  name: 'login',
  components: {
    LoadingAnimation,
  },
  data: () => ({
    error: false,
    state: '',
  }),
  methods: {
    async toggleError() {
      // eslint-disable-next-line no-bitwise
      this.error ^= true;

      await this.$nextTick();
    },
    async retryLogin() {
      this.toggleError();

      if (!this.$route.query.code) {
        await login(this);
      } else {
        await processLogin(this);
      }
    },
    async updateState(currentState = '') {
      this.state = currentState;

      await this.$nextTick();
    },
  },
  watch: {
    $route: {
      immediate: true,
      async handler() {
        if (await redirectIfLoggedIn(this)) {
          return;
        }

        if (!this.$route.query.code) {
          await login(this);
        } else {
          await processLogin(this);
        }
      },
    },
  },
};
</script>
